var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "a",
      {
        attrs: {
          href: "https://finance.yahoo.co.jp/quote/" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("Y")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "http://kabu3.freebbs.biz/shikihos/" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("四")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "http://kabu3.freebbs.biz/histories/" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("価")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "https://www.invest-jp.net/yuutai/detail/" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("逆")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "http://www.nisshokin.com/" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("証")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "http://kabu3.freebbs.biz/crosses/" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("カ")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "http://kabu3.freebbs.biz/crosses/smbc/" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("S")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "https://96ut.com/stock/index.php?code=" + _vm.code,
          target: "_blank",
        },
      },
      [_vm._v("玄")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "https://gokigen-life.tokyo/" + _vm.code + "yutai/",
          target: "_blank",
        },
      },
      [_vm._v("手")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }